<ion-app (click)="updateLastActivity()">
  <app-navigation *ngIf="showNav" />
  <ion-router-outlet [animated]="false" />
  <app-feedback-modal />
</ion-app>
